<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Bộ môn"
          :link="[
            { text: 'Nâng cao', href: '../subjectGroups' },
            { text: 'Bộ môn', href: '../subjectGroups' }
          ]"
        />
      </div>
      <div class="flex-center" v-if="canCreateSubjectGroup">
        <v-btn @click="createStateDialog = true" dark color="#0D47A1"> <v-icon left>add</v-icon>Thêm bộ môn </v-btn>
      </div>
    </div>
    <SubjectGroupDataTable :subjectGroups="subjectGroups" />

    <SubjectGroupNewDialog :state="createStateDialog" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import SubjectGroupNewDialog from '@/modules/subjectGroup/SubjectGroupNewDialog.vue'
import SubjectGroupDataTable from '@/modules/subjectGroup/SubjectGroupDataTable.vue'

export default {
  components: {
    SubjectGroupNewDialog,
    Breadcrumbs,
    SubjectGroupDataTable
  },
  data() {
    return {
      createStateDialog: false
    }
  },

  computed: {
    ...mapState('SubjectGroup', ['subjectGroups']),
    canCreateSubjectGroup() {
      return this.$auth.policies['add-new-subjectGroup']
    }
  },
  async created() {
    await this.refresh()
  },
  methods: {
    ...mapActions('SubjectGroup', ['fetchSubjectGroups']),
    updateDraw(draw) {
      this.draw = draw
    },
    refresh() {
      this.fetchSubjectGroups({ _sort: 'index:asc' })
    },
    onDivisionSelected(division) {
      this.setDivision(division)
    }
  }
}
</script>
